import React, { useEffect, useState, memo, forwardRef } from 'react';
import { View } from 'react-native';

import FieldLabel from './field_label';
import FieldTipText from './field_tip_text';
import FormHelpers from './helpers';

const ValidatedComponent = forwardRef((props, ref) => {
  const [requiredError, setRequiredError] = useState(false);
  const [validateError, setValidateError] = useState(false);
  const [touched, setTouched] = useState(false);

  function validate() {
    const { required = false, value, validateFunc, label } = props;
    const { validateError, requiredError } = FormHelpers.validateField(
      required,
      value,
      validateFunc
    );
    setValidateError(validateError);
    setRequiredError(requiredError);
    return !validateError && !requiredError;
  }

  React.useImperativeHandle(ref, () => ({
    validate,
  }));

  useEffect(
    function () {
      if (!touched && props.value) setTouched(true);
    },
    [props.value, touched]
  );

  useEffect(
    function () {
      if (touched && props.autoValidate !== false) validate();
    },
    [touched, props.value, props.required]
  );

  const flexibleHeight = props.flexibleHeight !== false;
  const readOnly = props.readOnly === true || props.editable === false;
  const heightStyle = flexibleHeight ? null : { height: 100 };

  return (
    <View style={[heightStyle, { marginTop: 10, marginBottom: 20 }, props.style]}>
      {!props.noLabel && !!props.label && (
        <FieldLabel
          label={props.label}
          extraLabel={props.extraLabel}
          required={props.required}
          value={props.value}
          readonly={readOnly}
          style={props.fieldLabelStyle}
        />
      )}
      {props.children}
      <FieldTipText
        containerStyle={props.fieldTextContainerStyle}
        flexibleHeight={flexibleHeight}
        tipText={props.tipText}
        requiredErrorText={props.requiredErrorText}
        invalidText={props.invalidText}
        label={props.label}
        requiredError={requiredError}
        validateError={validateError}
        readOnly={readOnly}
      />
    </View>
  );
});

export default memo(ValidatedComponent);
